import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

interface IconContainerProps {
  color: string;
}

interface ContainerProps {
  color: string;
}

export const Container = styled.div<ContainerProps>`
  position:relative;
  width: 100%;
  display: flex;
  height: 100%;
  min-height: 5rem;
  align-items: center;
  flex-direction: row;
  background: ${styleSheet.shape};
  color: ${styleSheet.shapeDark};
  border: 2px solid ${({ color }) => color};
  padding: 0;
  font-size: 1.2rem;
  cursor: pointer;
  white-space: normal;
  margin-top: 0.5rem;
  font-weight: bold;
  border-radius: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: auto; /* Let content dictate height */
    padding: 0.5rem 0;
  }
`;

export const Title = styled.h2`
  font-size: 1.4rem;
  color: ${styleSheet.shapeDark};
  font-weight: bold;
  display: inline;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Data = styled.div`
  width: 100%;
  text-align: center;
  padding: 0 2.5rem;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SubTitle = styled.p`
  font-size: 1rem;
  color: ${styleSheet.shapeMedium};
  font-weight: normal;
`;




export const DadgeContainer = styled.div`
  display: flex;
  position: absolute;
  top: -9px;
  right: -5px;

  @media (max-width: 768px) {
    position: static;
    display: contents;
  }
`;

export const LeftBadgeContainer = styled.div`
  display: flex;
  position: absolute;
  top: -9px;
  left: -5px;

  @media (max-width: 768px) {
     position: static;
     display: contents;
  }
`;

export const Dadge = styled.div<ContainerProps>`
  background: ${({ color }) => color};
  color: ${styleSheet.shape};
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 0.5rem;
  font-size: 1.2rem;
  font-weight: normal;

  @media (max-width: 768px) {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.8rem;
    margin: 1px 0; /* Reduced margin for tight stack */
  }

  /* Mobile Reordering */
  &.badge-status { @media (max-width: 768px) { order: 1; } }
  &.badge-coord { @media (max-width: 768px) { order: 2; } }
  &.badge-local { @media (max-width: 768px) { order: 3; } }
  &.badge-hour { @media (max-width: 768px) { order: 4; } }
`;

export const OsInfosContainer = styled.div`
  width: 8rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* background: ${styleSheet.shape}; */
  border-radius: 12px;
  margin-right: .5rem;
  padding: 0.5rem;
`;

export const OsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconContainer = styled.div<IconContainerProps>`
  width: 2rem;
  height: 2rem;  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ color }) => color};
  padding: 0.1rem;
  font-size: 1.6rem;
`;

export const Line = styled.div`
  width: 1px;
  height: 2rem;  
  background: ${styleSheet.shapeDark};
`;